import { Component, inject } from '@angular/core';
import { LoadingService } from'src/app/core/services/loading.service';
import { CommonModule } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { combineLatest } from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NativeAuthService } from 'src/app/core/auth/native-auth.service';

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [
    CommonModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss'
})
export class LoadingComponent {

  public service = inject(LoadingService);
  private router = inject(Router);
  private nativeAuth = inject(NativeAuthService);

  /**
   * Routes where the global loading overlay should be hidden.
   * These routes have their own branded loading UI.
   */
  private readonly hiddenRoutes = ['/callback', '/login'];

  /**
   * Observable that emits true when loading overlay should be shown.
   * Hides on specific routes that have their own loading UI, and while the
   * native (Capacitor) deep-link auth callback is being processed — the native
   * landing page shows its own full-screen spinner during that window, so the
   * global overlay would otherwise stack a second spinner on top of it.
   */
  shouldShowLoading$ = combineLatest([
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map((event: NavigationEnd) => event.urlAfterRedirects),
      startWith(this.router.url),
      map(url => !this.hiddenRoutes.some(route => url.startsWith(route))),
    ),
    this.nativeAuth.processingCallback$,
  ]).pipe(
    map(([routeAllowsOverlay, processingNativeCallback]) =>
      routeAllowsOverlay && !processingNativeCallback,
    ),
  );
}
